import type { UseQueryResult } from "@tanstack/react-query";
import type { ReactNode } from "react";

interface Props<T> {
  query: UseQueryResult<T>;
  empty?: ReactNode;
  children: (data: T) => ReactNode;
}

/**
 * Ladezustand, Fehler und Leerfall an einer Stelle.
 *
 * Der Fehlertext wird angezeigt und nicht verschluckt: bei einem Werkzeug,
 * das im Hintergrund laeuft, ist "es fehlt etwas, und zwar dies" die
 * nuetzlichere Auskunft als eine leere Seite.
 */
export function Async<T>({ query, empty, children }: Props<T>) {
  if (query.isPending) return <p className="muted">Lädt …</p>;
  if (query.isError) {
    return <div className="notice error">Fehler beim Laden: {String(query.error)}</div>;
  }
  const data = query.data as T;
  if (empty && Array.isArray(data) && data.length === 0) {
    return <div className="notice">{empty}</div>;
  }
  return <>{children(data)}</>;
}
